import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12.01 4.45a4.003 4.003 0 1 0 0 8.007 4.003 4.003 0 0 0 0-8.007M10.01 8.454a2.002 2.002 0 1 1 4.003 0 2.002 2.002 0 0 1-4.003 0",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12.01 23.02c6.081 0 11.01-4.93 11.01-11.01S18.091 1 12.01 1 1.002 5.93 1.002 12.01s4.93 11.01 11.01 11.01m0-2.002c2.4 0 4.58-.938 6.195-2.468a8.76 8.76 0 0 0-6.194-2.552 8.76 8.76 0 0 0-6.195 2.552 8.98 8.98 0 0 0 6.195 2.468m0-7.022c2.91 0 5.55 1.151 7.49 3.02a9.008 9.008 0 1 0-14.98 0c1.941-1.869 4.582-3.02 7.49-3.02",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }